var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq25(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.477734,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7141,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.3015,
    y1: 12.1824,
    x2: 49.5379,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.627712,
    y1: 49.8543,
    x2: 11.864,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.0637,
    y1: 38.6199,
    x2: 49.3,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.389866,
    y1: 0.944118,
    x2: 11.6262,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.714 30.23C19.4313 28.942 20.7567 27.7893 21.69 26.772C22.6327 25.7453 23.104 24.742 23.104 23.762C23.104 23.118 22.9407 22.6047 22.614 22.222C22.2967 21.83 21.774 21.634 21.046 21.634C20.3367 21.634 19.786 21.858 19.394 22.306C19.0113 22.7447 18.7967 23.3327 18.75 24.07H17.798C17.854 23.034 18.1713 22.2313 18.75 21.662C19.338 21.0833 20.1033 20.794 21.046 20.794C21.9513 20.794 22.684 21.0507 23.244 21.564C23.804 22.068 24.084 22.7867 24.084 23.72C24.084 24.8493 23.6127 25.946 22.67 27.01C21.7367 28.0647 20.584 29.096 19.212 30.104H24.392V30.93H17.714V30.23ZM32.2497 21.802H27.1257V25.386C27.3591 25.0593 27.6997 24.7933 28.1477 24.588C28.5957 24.3733 29.0811 24.266 29.6037 24.266C30.3691 24.266 30.9944 24.4247 31.4797 24.742C31.9651 25.05 32.3151 25.456 32.5297 25.96C32.7444 26.4547 32.8517 26.9867 32.8517 27.556C32.8517 28.2093 32.7257 28.802 32.4737 29.334C32.2311 29.8567 31.8531 30.272 31.3397 30.58C30.8357 30.888 30.2057 31.042 29.4497 31.042C28.4884 31.042 27.7091 30.7947 27.1117 30.3C26.5144 29.796 26.1504 29.1193 26.0197 28.27H26.9857C27.1071 28.886 27.3871 29.362 27.8257 29.698C28.2644 30.034 28.8057 30.202 29.4497 30.202C30.2617 30.202 30.8731 29.964 31.2837 29.488C31.7037 29.0027 31.9137 28.3633 31.9137 27.57C31.9137 26.7953 31.7037 26.1933 31.2837 25.764C30.8637 25.3253 30.2617 25.106 29.4777 25.106C28.9364 25.106 28.4604 25.232 28.0497 25.484C27.6391 25.736 27.3357 26.0767 27.1397 26.506H26.2157V20.948H32.2497V21.802Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq25);
export default __webpack_public_path__ + "static/media/fq25.1d8f34031eb3e15b5b924dbc115fdd68.svg";
export { ForwardRef as ReactComponent };